import * as WebBrowser from 'expo-web-browser';
import * as React from 'react';
import { Alert, Platform, StyleSheet, ToastAndroid } from 'react-native';
import {
  Box,
  Heading,
  Center,
  Stack,
  Spacer,
  Button,
  ChevronRightIcon,
  Radio,
  Text,
  FormControl,
  Input,
  VStack,
  KeyboardAvoidingView,
  ScrollView,
  HStack
} from 'native-base';
import { FormContext } from '../../stores/Store.tsx';
import PreLoader from '../../components/PreLoader';
import { SafeAreaView } from 'react-native-safe-area-context';
import { isFormEnded } from '../../hooks/isFormEnd';

var numeral = require('numeral');


export default function AirTankScreen(props) {
  const { navigation } = props;
  let [form, setForm] = React.useContext(FormContext);
  const [formData, setFormData] = React.useState({});
  const [working, setWorking] = React.useState(false);

  const handleChange = (data) => {
    setFormData((prev) => {
      return {
        ...prev, ...data
      }
    });
  }

  const handleChangeForm = (data) => {
    const formData = { ...form }
    formData.questions.air_tanks = { data, order: 6 };
    console.log(formData);
    setForm({ ...form, ...formData });
  }

  const continueForm = () => {
    handleChangeForm(formData)
    if (formData.strange_object_air_tanks.value || formData.double_bottom_air_tanks.value) {
      setWorking(true)
      form.endAt = new Date();
      isFormEnded(() => navigation.navigate('HomeScreen'), form)
    } else {
      navigation.navigate('FifthWheelScreen')
    }

  }


  if (working) {
    return <PreLoader />;
  }


  return (
    <Center flex={1}>
      <SafeAreaView style={{ flex: 1, padding: 10 }}>
        <KeyboardAvoidingView
          h={{
            // base: "400px",
            lg: "auto",
          }}
          behavior={Platform.OS === "ios" ? "padding" : "height"}
        >
          <VStack
            rounded="lg"
            overflow="hidden"
            width={{
              base: 'xs',
              sm: 'xl',
              md: 768,
              lg: 992,
              xl: 1280,
            }}
            height="full"
            shadow={1}
            _light={{ backgroundColor: 'gray.50' }}
            _dark={{ backgroundColor: 'gray.700' }}
            flex="1"
            justifyContent="flex-end"
          >
            <ScrollView
              _contentContainerStyle={{
                px: "20px",
                mb: "4",
                minW: "72",
              }}
            >
              <Stack p="4" space={3}>
                <Stack space={2}>
                  <Heading size="md" ml="-1">
                    {`Inspector: ${form.inspector}`}
                  </Heading>
                </Stack>
                <Text fontWeight="400">
                  {`Criterios para evaluar las preguntas siguientes responde `}
                  <Text fontWeight="bold">SI </Text>
                  <Text >o</Text>
                  <Text fontWeight="bold"> NO </Text>
                  {`según corresponda`}
                </Text>
                <Text fontWeight="400">
                  {`6) Tanques de aire`}
                </Text>
                <FormControl on>
                  <Stack space={2}>
                    <FormControl isRequired>
                      <Stack>
                        <FormControl.Label>Al utilizar la linterna se observa algún doble fondo o compartimiento secreto</FormControl.Label>
                        <Radio.Group
                          name="myRadioGroup"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ double_bottom_air_tanks: { value: nextValue, q: 'Al utilizar la linterna se observa algún doble fondo o compartimiento secreto', critic: true } });
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </Stack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.double_bottom_air_tanks.observations = text} placeholder="Observaciones" />
                    </Stack>
                    <FormControl isRequired>
                      <Stack>
                        <FormControl.Label>Se detecta algún objeto sospechoso en el interior del tanque</FormControl.Label>
                        <Radio.Group
                          name="myRadioGroup"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ strange_object_air_tanks: { value: nextValue, q: 'Se detecta algún objeto sospechoso en el interior del tanque', critic: true } });
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </Stack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.strange_object_air_tanks.observations = text} placeholder="Observaciones" />
                    </Stack>
                    <FormControl>
                      <VStack>
                        <FormControl.Label>Se detecta tornillería nueva o pintura reciente</FormControl.Label>
                        <Radio.Group
                          name="myRadioGroup"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ new_screws_air_tanks: { value: nextValue, q: 'Se detecta tornillería nueva o pintura reciente' } })
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </VStack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.new_screws_air_tanks.observations = text} placeholder="Observaciones" />
                    </Stack>
                  </Stack>
                </FormControl>
              </Stack>
            </ScrollView>
            <Spacer />
            <Box>
              <HStack>
                <Spacer />
                <Button
                  disabled={formData.strange_object_air_tanks === undefined ||
                    formData.new_screws_air_tanks === undefined
                    || formData.double_bottom_air_tanks === undefined
                  }
                  rightIcon={<ChevronRightIcon color="white" />}
                  colorScheme={formData.strange_object_air_tanks !== undefined &&
                    formData.new_screws_air_tanks !== undefined &&
                    formData.double_bottom_air_tanks !== undefined
                    ? "info" : "gray"
                  }
                  size="md"
                  onPress={() => continueForm()}
                >
                  Continuar
                </Button>
              </HStack>
            </Box>

          </VStack>
        </KeyboardAvoidingView>
      </SafeAreaView>
    </Center>
  );
}
